var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.status),expression:"status"}],staticClass:"contextmenu-wrap",style:(_vm.style)},[_c('ContextMenu',{attrs:{"icon":_vm.icon,"menu":_vm.menu,"resolve":_vm.resolve}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }